/**
 * Cotización técnica
 *
 */
import React from 'react'
import { Table, Button, Modal, message, Input, Divider, Icon, Skeleton, Tooltip } from 'antd'
import Api from '../../../Api'
import Exception from '../../../Exception'
import Crud from '../../../components/Crud'
import { connect } from 'react-redux'
import Column from 'antd/lib/table/Column'

class CotizacionTecnica extends React.Component {
  /**
   * Constructor
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      columns: [],
      loading: false,
      cotizacionId: -2,
      comparativaId: -2,
      cotizacionPendiente: false,
      grupo: -2,
    }
  }

  /**
   * Load
   *
   * @param {Number} comparativaId
   * @param {Number} cotizacionId
   */
  load = async (comparativaId) => {
    try {
      this.setState({
        comparativaId,
        visible: true,
        loading: true,
        data: [],
      })

      const { data: cotizacion } = await Api.query.first({
        attributes: ['iId'],
        model: 'ComCuadroComparativoProveedor',
        where: {
          iIdCuadro: comparativaId,
          iIdProveedor: Api.getProviderId(),
          iActivo: true,
        }
      })

      if (!cotizacion) {
        throw new Error('Proveedor no encontrado en la cotización')
      }

      const cotizacionId = cotizacion.iId
      this.setState({ cotizacionId })

      const response = await Api.query.list({
        firmas: {
          model: 'ComCuadroComparativoFirma',
          attributes: ['iId'],
          where: {
            iIdCuadro: comparativaId,
            iIdUsuario: { $gt: 0 },
            iActivo: true,
          },
          limit: 1,
        },

        grupos: {
          model: 'ComFamiliaCotizacionTecnicaGrupo',
          attributes: ['iId', 'sNombre'],
          include: [{
            as: 'propiedades',
            required: true,
            attributes: ['iId', 'sNombre'],
            include: [{
              as: 'cotizacionTecnica',
              required: false,
              attributes: ['iId', 'sParametrosEvaluacion', 'sAlternativa', 'sCumple', 'sNoCumple', 'sDesviacionMenor'],
              where: {
                iIdCotizacion: cotizacionId,
                iActivo: true,
              }
            }],
            where: {
              iActivo: true,
            }
          }],
          where: {
            iActivo: true,
          },
          order: [['iOrden', 'asc']]
        }
      })

      this.setState({
        loading: false,
        data: response.data.grupos,
        grupo: response.data.grupos.length ? response.data.grupos[0].iId : -2,
        cotizacionPendiente: response.data.firmas.length === 0,
      })
    } catch (error) {
      this.setState({ loading: false })
      Exception.load(error).show()
    }
  }

  /**
   * saveAll
   */
  saveAll = (callback) => {
    this.setState({ loading: true })

    const grupos = this.state.data
      .filter(grupo => grupo.changed)
      .map(grupo =>
        ({
          ...grupo,
          propiedades: grupo.propiedades.filter(item => item.changed)
        })
      )
      .filter(grupo => grupo.propiedades.length)

    const items = []
    for (const grupo of grupos) {
      for (const propiedad of grupo.propiedades) {
        items.push({
          iIdCotizacion: this.state.cotizacionId,
          iIdPropiedad: propiedad.iId,
          sParametrosEvaluacion: propiedad.cotizacionTecnica.sParametrosEvaluacion,
          sAlternativa: propiedad.cotizacionTecnica.sAlternativa,
          sCumple: propiedad.cotizacionTecnica.sCumple,
          sNoCumple: propiedad.cotizacionTecnica.sNoCumple,
          sDesviacionMenor: propiedad.cotizacionTecnica.sDesviacionMenor,
        })
      }
    }

    if (grupos.length) {
      Api.post(`/com/cotizaciones/proveedores/${this.state.cotizacionId}/tecnica`, { items })
        .then(() => {
          this.setState({ loading: false })
          message.success('Datos guardados')
          callback && callback()
        })
        .catch(error => {
          Exception.load(error).show()
          this.setState({ loading: false })
        })
    } else {
      this.setState({ loading: false })
    }
  }

  /**
   * onGrupoSeleccionado
   */
  onGrupoSeleccionado = (grupo) => {
    this.setState({ grupo: grupo.iId })
  }

  /**
   * setGroup
   */
  setGroup =(grupo, propiedad, key, value) => {
    if (!this.state.cotizacionPendiente) {
      return
    }

    this.setState({
      data: this.state.data.map(
        _g => _g.iId !== grupo.iId ? _g : ({
          ..._g,
          propiedades: _g.propiedades.map(
            _p => _p.iId !== propiedad.iId ? _p : ({
              ..._p,
              changed: true,
              cotizacionTecnica: {
                ..._p.cotizacionTecnica,
                [key]: value,
              }
            })
          ),
          changed: true,
        })
      )
    })
  }

  /**
   * Render
   *
   */
  render() {
    const { theme } = this.props
    const crud = (
      <Crud
        buttons={['reload']}
        onReload={() => this.load(this.state.cotizacionId)}
        onAdd={this.nuevoAdjunto}
        children={[
          <Tooltip key='techQuotationPDF' title='Cotización ténica'>
            <a
              href={Api.to(`/com/cotizaciones/proveedores/${this.state.cotizacionId}/tecnica/pdf`)}
              download={`COTIZACION-${this.state.cotizacionId}-TECNICA.pdf`}
              target='_blank'
              rel='noopener noreferrer'
              children={
                <Icon type='file-pdf' />
              }
            />
          </Tooltip>
        ]}
      />
    )

    const seleccionado = this.state.data.find(item => item.iId === this.state.grupo) || { propiedades: [] }

    return (
      <Modal
        title='COTIZACIÓN TÉCNICA'
        visible={this.state.visible}
        onOk={this.onSave}
        style={{ minWidth: '90%' }}
        onCancel={() => this.setState({ visible: false })}
        footer={[
          <Button
            key='close'
            loading={this.state.loading}
            onClick={() => this.setState({ visible: false })}
            children='CANCELAR'
          />,
          <Button
            key='save'
            type='primary'
            loading={this.state.loading}
            onClick={() =>
              this.saveAll(() => this.setState({ visible: false }))
            }
            children='GUARDAR'
          />
        ]}
        children={
          <Skeleton loading={this.state.load}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div style={{ alignSelf: 'flex-start' }}>
                {this.state.data.map(grupo => (
                  <div
                    key={grupo.iId.toString()}
                    style={{
                      cursor: 'pointer',
                      marginBottom: 1,
                      marginTop: 6,
                      borderBottomStyle: 'solid',
                      borderBottomWidth: 1,
                      borderBottomColor: this.state.grupo.iId !== grupo.iId ? 'transparent' : theme.colors.text
                    }}
                    children={
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Icon type='number' style={{ marginRight: 5, color: theme.colors[this.state.grupo === grupo.iId ? 'accent' : 'text'] }} />
                        <h5 style={{ margin: 0, color: theme.colors[this.state.grupo === grupo.iId ? 'accent' : 'text'] }}>{grupo.sNombre}</h5>
                      </div>
                    }
                    onClick={() => this.onGrupoSeleccionado(grupo)}
                  />
                ))}
              </div>
              <Divider type='vertical' />
              <div style={{ flex: 1 }}>
                <Table
                  rowKey='iId'
                  size='small'
                  pagination={false}
                  dataSource={seleccionado.propiedades}
                  bordered={false}
                  title={() => (
                    <div>
                      {crud}
                    </div>
                  )}
                >
                  <Column width={'30%'} title='DESCRIPCIÓN' dataIndex='sNombre' />
                  <Column width={'20%'} title='PARÁMETROS DE EVALUACIÓN' dataIndex='cotizacionTecnica.sParametrosEvaluacion' render={(val, propiedad) => (
                    <div>
                      <Input.TextArea
                        value={val}
                        onChange={e => this.setGroup(seleccionado, propiedad, 'sParametrosEvaluacion', e.target.value)}
                      />
                    </div>
                  )} />
                  <Column width={'20%'} title='ALTERNATIVA' dataIndex='cotizacionTecnica.sAlternativa' render={(val, propiedad) => (
                    <div>
                      <Input.TextArea
                        value={val}
                        onChange={e => this.setGroup(seleccionado, propiedad, 'sAlternativa', e.target.value)}
                      />
                    </div>
                  )} />
                  <Column width='7%' title='CUMPLE' dataIndex='cotizacionTecnica.sCumple' render={(val, propiedad) => (
                    <div style={styles.checkContainer} onClick={() => this.setGroup(seleccionado, propiedad, 'sCumple', val === 'C' ? null : 'C')}>
                      <div style={{ ...styles.checkItem, background: val === 'C' ? theme.colors.accent : 'transparent', color: val === 'C' ? 'black' : theme.colors.text }}>C</div>
                    </div>
                  )} />
                  <Column width='10%' title='NO CUMPLE' dataIndex='cotizacionTecnica.sNoCumple' render={(val, propiedad) => (
                    <div style={styles.checkContainer} onClick={() => this.setGroup(seleccionado, propiedad, 'sNoCumple', val === 'NC' ? null : 'NC')}>
                      <div style={{ ...styles.checkItem, background: val === 'NC' ? theme.colors.accent : 'transparent', color: val === 'NC' ? 'black' : theme.colors.text }}>NC</div>
                    </div>
                  )} />
                  <Column width='13%' title='DESVIACIÓN MENOR' dataIndex='cotizacionTecnica.sDesviacionMenor' render={(val, propiedad) => (
                    <div style={styles.checkContainer} onClick={() => this.setGroup(seleccionado, propiedad, 'sDesviacionMenor', val === 'DA' ? null : 'DA')}>
                      <div style={{ ...styles.checkItem, background: val === 'DA' ? theme.colors.accent : 'transparent', color: val === 'DA' ? 'black' : theme.colors.text }}>DA</div>
                    </div>
                  )} />
                </Table>
              </div>
            </div>
          </Skeleton>
        }
      />
    )
  }
}

const styles = {
  checkContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  checkItem: {
    borderRadius: 2,
    width: 30,
    height: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  }
}

export default connect(
  state => ({
    theme: state.theme.values
  }),
  undefined,
  undefined,
  { forwardRef: true }
)(CotizacionTecnica)
